import { Result, ValidationResult } from "nutso";
import { ButtonType } from "./ButtonType";

export const successValidation: ValidationResult = { isValid: true, errorMessage: "", errorPath: [] };

type Props = {
  testId?: string;
  children: string;
  onClick: () => void;
  icon?: string;
  disabled?: boolean;
  className?: string;
  type?: ButtonType;
  validation?: Result<any>;
  busy?: boolean;
  busyLabel?: string;
  _ref?: (ref: HTMLButtonElement | null) => void;
  dataCy?: string;
};

export const Button = (props: Props) => {
  //
  const renderIcon = () => {
    const { icon, busy } = props;
    if (busy) {
      return <i className="spin icon las la-circle-notch"></i>;
    }
    if (!icon) return;
    return <i className={`icon las ${icon}`}></i>;
  };

  const {
    children,
    onClick,
    disabled,
    className,
    validation = successValidation,
    testId,
    type,
    busy,
    busyLabel,
    _ref,
    dataCy,
  } = props;
  const _disabled = disabled || !validation.isValid || busy;
  return (
    <button
      id={testId}
      disabled={_disabled}
      className={`${className ?? ""} ${_disabled ? "disabled" : ""} ${type ?? ""}`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (_disabled) return;
        onClick();
      }}
      ref={_ref}
      data-cy={dataCy}
    >
      {renderIcon()}
      <span className="label">{busy ? busyLabel ?? children : children}</span>
    </button>
  );
};
